import {ProductInfo} from './productInfo';

export class Product {

  productInfo: ProductInfo;

  constructor(productID: string, productName: string) {
    this.productInfo = new ProductInfo(productID, productName);
  }

  public getProductInfo(): ProductInfo {
    return this.productInfo;
  }
}
